import { render, staticRenderFns } from "./TextCapitalize1Icon.vue?vue&type=template&id=59f4f114&"
import script from "./TextCapitalize1Icon.vue?vue&type=script&lang=js&"
export * from "./TextCapitalize1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports